import * as ActionTypes from './actionTypes';

export const actionGetActionHistories = (payload) => ({
  type: ActionTypes.GET_ACTION_HISTORIES,
  payload,
});

export const actionGetActionHistoriesSuccess = (payload) => ({
  type: ActionTypes.GET_ACTION_HISTORIES_SUCCESS,
  payload,
});

export const actionGetActionHistoriesFailed = () => ({
  type: ActionTypes.GET_ACTION_HISTORIES_FAILED,
});

export const actionExportActionHistories = (payload) => ({
  type: ActionTypes.EXPORT_ACTION_HISTORIES,
  payload,
});

export const actionExportActionHistoriesSuccess = () => ({
  type: ActionTypes.EXPORT_ACTION_HISTORIES_SUCCESS,
});

export const actionExportActionHistoriesFailed = () => ({
  type: ActionTypes.EXPORT_ACTION_HISTORIES_FAILED,
});
